<div id="fss-portal-error-dialog" class="dialog">
  @if (!disableClose) {
    <button
      mat-icon-button
      mat-dialog-close
      id="fss-portal-error-dialog-close"
      class="btn-close"
      aria-label="Close"
      type="button"
      color="primary"
      >
      <mat-icon>close</mat-icon>
    </button>
  }

  <div mat-dialog-content>
    <div class="message-hdr">{{ message }}</div>
    @if (showLogin) {
      <p class="message-subhdr">Please login to continue</p>
    }
  </div>
  @if (showLogin) {
    <div mat-dialog-actions align="center">
      @if (allowsGuest) {
        <button mat-stroked-button class="guest-btn" mat-dialog-close (click)="continueAsGuest()">
          Continue as Guest
        </button>
      }
      <button mat-stroked-button class="login-btn" color="primary" mat-dialog-close (click)="doLogin()">
        Go to Login
      </button>
    </div>
  }

  @if (error || messageCode) {
    <div>
      <mat-accordion>
        <mat-expansion-panel hideToggle #panel>
          <mat-expansion-panel-header class="learn-more-header">
            <mat-panel-title>
              Learn More
              <mat-icon>{{ panel.expanded ? "keyboard_arrow_up" : "keyboard_arrow_down" }}</mat-icon>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="additional-info">
            <span>{{ learnMoreMessage }}</span>
            <div>
              <span class="tech-details">Technical Details</span>
              <span (click)="copyToClipboard()" class="to-copy" title="Copy To Clipboard">
                <mat-icon [svgIcon]="Icons.CONTENT_COPY" aria-label="Copy To Clipboard"></mat-icon>
                Copy
              </span>
            </div>
            <p class="error-code">Error Code {{ messageCode }}</p>
            <p>{{ error }}</p>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  }
</div>
